import { MappingMonth } from 'src/const/dateEnum'

export const generateMediaUrl = (url: string): string => {
  if (url && !url.startsWith('http')) {
    return `${process.env.PRIVAGE_MEDIA_URL}${url}`
  }
  return url
}

export const generateYearList = (currentLangauge: string) => {
  const startYear = new Date().getFullYear() - 120;
  const endYear = new Date().getFullYear();
  const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
    label: currentLangauge === 'th' ? `${i + startYear + 543}` : `${i + startYear}`,
    value: i + startYear,
  }));

  return years;
}

export const generateMonthList = (currentLangauge: string) => {
  const months = Array.from({ length: 12 }, (_, i) => ({
    label: MappingMonth[i][`${currentLangauge === 'th' ? 'th' : 'en'}`],
    value: i + 1,
  }));

  return months;
}

export const generateDayList = (year: number | null, month: number | null) => {
  if (year && month) {
    const numDays = new Date(year, month, 0).getDate();
    const days = Array.from({ length: numDays }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }));
    return days;
  } else {
    return []
  }
}

export const formattedDataToNumber = (raw: string | null, fillZero?: boolean) => {
  try {
    if (raw) {
      const regex = /\b0([1-9])\b/g
      if (fillZero) {
        const regex = /\b([1-9])\b/g;
        const results = raw.replace(regex, '0$1');
        return results;
      } else {
        const results = raw?.replace(
          regex,
          (_match: string, digit: string) => digit
        )
        return results
      }
    } else {
      return ''
    }
  } catch (error) {
    return raw
  }
}

export const generateLabelRequireField = (originalLabel: string, require: boolean) => {
  if (require) {
    return `${originalLabel} *`
  } else {
    return `${originalLabel}`
  }
}